// @flow
import * as React from "react";

import styles from "./TabContent.scss";

type TabContentProps = {
  content: () => React.Node
};

const TabContent = ({ content }: TabContentProps) => (
  <div className={styles.tabContent}>{content()}</div>
);

export default TabContent;
